import React, { useEffect, useState } from "react";
import {
  fetchMisDirecciones, crearDireccion, actualizarDireccion,
  eliminarDireccion, marcarDireccionDefecto,
} from "../services/api";

const VACIO = { direccion: "", comuna: "", ciudad: "" };

function MisDirecciones() {
  const [lista,    setLista]    = useState([]);
  const [form,     setForm]     = useState(VACIO);
  const [editando, setEditando] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [loading,  setLoading]  = useState(true);

  const cargar = () => {
    setLoading(true);
    fetchMisDirecciones()
      .then(res => setLista(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { cargar(); }, []);

  const handleNueva = () => {
    setEditando(null);
    setForm(VACIO);
    setShowForm(true);
  };

  const handleEditar = (dir) => {
    setEditando(dir.id);
    setForm({ direccion: dir.direccion, comuna: dir.comuna, ciudad: dir.ciudad });
    setShowForm(true);
  };

  const handleEliminar = async (id) => {
    if (!window.confirm("¿Eliminar esta dirección?")) return;
    await eliminarDireccion(id).catch(() => {});
    cargar();
  };

  const handleMarcarDefault = async (id) => {
    await marcarDireccionDefecto(id).catch(() => {});
    cargar();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const esPrimeraDireccion = lista.length === 0 && !editando;
    const payload = { ...form, ...(esPrimeraDireccion ? { esPorDefecto: true } : {}) };
    if (editando) {
      await actualizarDireccion(editando, payload).catch(() => {});
    } else {
      await crearDireccion(payload).catch(() => {});
    }
    setShowForm(false);
    setEditando(null);
    setForm(VACIO);
    cargar();
  };

  const handleCampo = (e) =>
    setForm(prev => ({ ...prev, [e.target.name]: e.target.value }));

  if (loading) return <p style={{ textAlign: "center", marginTop: 40 }}>Cargando...</p>;

  return (
    <div style={st.contenedor}>
      <h2>📍 Mis Direcciones</h2>

      {!showForm && (
        <button onClick={handleNueva} style={st.btnAgregar}>➕ Nueva dirección</button>
      )}

      {showForm && (
        <form onSubmit={handleSubmit} style={st.form}>
          <h3 style={{ margin: "0 0 12px" }}>
            {editando ? "✏️ Editar dirección" : "➕ Nueva dirección"}
          </h3>

          {[
            { name: "direccion", label: "Dirección", placeholder: "Av. Ejemplo 1234" },
            { name: "comuna",    label: "Comuna",    placeholder: "Las Condes" },
            { name: "ciudad",    label: "Ciudad",    placeholder: "Santiago" },
          ].map(({ name, label, placeholder }) => (
            <div key={name} style={{ marginBottom: 10 }}>
              <label style={st.label}>{label}</label>
              <input
                name={name} value={form[name]} onChange={handleCampo}
                placeholder={placeholder} required style={st.input}
              />
            </div>
          ))}

          <div style={{ display: "flex", gap: 8 }}>
            <button type="submit" style={st.btnGuardar}>
              {editando ? "💾 Actualizar" : "💾 Guardar"}
            </button>
            <button type="button" onClick={() => setShowForm(false)} style={st.btnCancelar}>
              Cancelar
            </button>
          </div>
        </form>
      )}

      {lista.length === 0 && !showForm ? (
        <p style={{ color: "#888", marginTop: 16 }}>No tienes direcciones guardadas.</p>
      ) : (
        <div style={{ marginTop: 20 }}>
          {lista.map(dir => (
            <div key={dir.id} style={{ ...st.tarjeta, ...(dir.esPorDefecto ? st.tarjetaDefault : {}) }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                <div>
                  <p style={st.linea}>📍 {dir.direccion}</p>
                  <p style={st.linea}>{dir.comuna}, {dir.ciudad}</p>
                </div>
                {dir.esPorDefecto && (
                  <span style={st.badgePrincipal}>Principal</span>
                )}
              </div>
              <div style={{ display: "flex", gap: 8, marginTop: 10, flexWrap: "wrap" }}>
                {!dir.esPorDefecto && (
                  <button onClick={() => handleMarcarDefault(dir.id)} style={st.btnPrincipal}>
                    ⭐ Marcar como principal
                  </button>
                )}
                <button onClick={() => handleEditar(dir)} style={st.btnEditar}>✏️ Editar</button>
                <button onClick={() => handleEliminar(dir.id)} style={st.btnEliminar}>🗑️ Eliminar</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const st = {
  contenedor: { maxWidth: 600, margin: "0 auto", padding: "24px 16px" },
  form: {
    display: "flex", flexDirection: "column",
    border: "1px solid #e5e7eb", borderRadius: 8,
    padding: 16, marginBottom: 20, backgroundColor: "#fafafa",
  },
  label:   { display: "block", fontSize: 12, marginBottom: 4, color: "#555", fontWeight: 600 },
  input:   { width: "100%", padding: "8px 10px", border: "1px solid #ccc", borderRadius: 4, boxSizing: "border-box" },
  tarjeta: {
    border: "1px solid #e5e7eb", borderRadius: 8, padding: "12px 16px",
    marginBottom: 12, backgroundColor: "#fff",
  },
  tarjetaDefault: {
    border: "1px solid #1a1a2e", backgroundColor: "#f8f8ff",
  },
  linea:          { margin: "2px 0", fontSize: 14 },
  badgePrincipal: {
    backgroundColor: "#1a1a2e", color: "#fff",
    fontSize: 11, padding: "3px 10px", borderRadius: 10, whiteSpace: "nowrap",
  },
  btnAgregar:   { padding: "8px 18px", backgroundColor: "#1a1a2e", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" },
  btnGuardar:   { padding: "8px 18px", backgroundColor: "#1a1a2e", color: "#fff", border: "none", borderRadius: 6, cursor: "pointer" },
  btnCancelar:  { padding: "8px 18px", backgroundColor: "#e5e7eb", color: "#333", border: "none", borderRadius: 6, cursor: "pointer" },
  btnPrincipal: { padding: "4px 12px", backgroundColor: "#fefce8", color: "#854d0e", border: "1px solid #fde68a", borderRadius: 4, cursor: "pointer", fontSize: 13 },
  btnEditar:    { padding: "4px 12px", backgroundColor: "#f0f9ff", color: "#0369a1", border: "1px solid #bae6fd", borderRadius: 4, cursor: "pointer", fontSize: 13 },
  btnEliminar:  { padding: "4px 12px", backgroundColor: "#fee2e2", color: "#991b1b", border: "1px solid #fecaca", borderRadius: 4, cursor: "pointer", fontSize: 13 },
};

export default MisDirecciones;
